/*
 *
 * OptionsRibbon
 *
 */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInjectReducer } from 'utils/injectReducer';
import { createStructuredSelector } from 'reselect';
import reducer from 'containers/Ribbon/OptionsRibbon/reducer';
import { RootState } from 'containers/Ribbon/OptionsRibbon/types';
import RibbonSection from 'containers/Ribbon/RibbonSection';
import supportImg from 'assets/images/ribbons/cabinetRibbon/support.png';
import { displaySupportPanelAction } from 'containers/SupportPanel/actions';
import BigSelector from 'components/BigSelector';
import { Checkbox } from '@material-ui/core';
import { StyledRibbonWrapper } from 'containers/Ribbon/StyledRibbonWrapper';
import withStyles from '@material-ui/core/styles/withStyles';
import { green } from '@material-ui/core/colors';
import { CheckboxProps } from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeSelectIsActiveCustomMode } from 'containers/Configurator/selectors/general';
import { toggleToggleCustomModeAction } from 'containers/Configurator/actions/general';
import { useTranslation } from 'react-i18next';

interface StateProps {
  customMode: boolean;
}

const stateSelector = createStructuredSelector<RootState, StateProps>({
  customMode: makeSelectIsActiveCustomMode(),
});

function OptionsRibbon() {
  useInjectReducer({ key: 'optionsRibbon', reducer: reducer });
  const dispatch = useDispatch();
  const { customMode } = useSelector(stateSelector);
  const { t } = useTranslation();

  const KewloxCheckbox = withStyles({
    checked: {
      color: green[400],
      '&$checked': {
        color: green[600],
      },
    },
  })((props: CheckboxProps) => <Checkbox color="default" {...props} />);

  return (
    <StyledRibbonWrapper>
      <RibbonSection border>
        <BigSelector
          imgSrc={supportImg}
          imgAlt="top"
          title={t('Upper tablet')}
          handleClick={() => {
            dispatch(displaySupportPanelAction(true));
          }}
        />
      </RibbonSection>

      <RibbonSection border>
        <FormControlLabel
          control={
            <Checkbox
              checked={customMode}
              onChange={() => {
                dispatch(toggleToggleCustomModeAction(!customMode));
              }}
              value="checkedG"
              color="primary"
            />
          }
          label={t('Custom mode')}
        />
      </RibbonSection>
      <RibbonSection border>
        <div className="flex flex-wrap">
          <FormControlLabel
            control={
              <Checkbox
                checked={false}
                onChange={() => {
                  console.log('Checkbox checked');
                }}
                value="checkedG"
                color="primary"
              />
            }
            label={t('Lighting')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={false}
                onChange={() => {
                  console.log('Checkbox checked');
                }}
                value="checkedG"
                color="primary"
              />
            }
            label={t('Lock')}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={false}
                onChange={() => {
                  console.log('Checkbox checked');
                }}
                value="checkedG"
                color="primary"
              />
            }
            label={t('Backpane with hole (10cm)')}
          />
        </div>
      </RibbonSection>
    </StyledRibbonWrapper>
  );
}

export default OptionsRibbon;
